module.exports = __webpack_public_path__ + "static/media/17c-03_ST-2017-200x150cm-oleo-sobre-madera.0b99604f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17c/17c-03_ST-2017-200x150cm-oleo-sobre-madera.jpg
// module id = 212
// module chunks = 0